define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext", "../../models/CommissionRoleModel", "../../utils/LookupDataSources"], function (require, exports, $, ko, log, tools, KendoUtils, UserContext, CommissionRoleModel, LookupDataSources) {
    "use strict";
    var CommissionRoleActions = /** @class */ (function () {
        function CommissionRoleActions(employeeId) {
            this.userCanEditCommissionRole = ko.observable(UserContext.hasAccess("Admin,CommissionRole.Edit,CommissionRole.Delete"));
            this.userCanDeleteCommissionRole = ko.observable(UserContext.hasAccess("Admin,CommissionRole.Delete"));
            this.filterByAny = ko.observable();
            this.editModel = ko.observable(new CommissionRoleModel());
            this.commissionRoleRates = [];
            this.bulkIsFlat = ko.observable(false);
            this.bulkRate = ko.observable(0);
            this.bulkRateFormat = ko.observable("p2");
            var self = this;
            self.employeeId = employeeId;
            self.bulkIsFlat.subscribe(function () {
                if (self.bulkIsFlat()) {
                    self.bulkRateFormat("c2");
                }
                else {
                    self.bulkRateFormat("p2");
                }
            });
        }
        CommissionRoleActions.prototype.initRolesList = function () {
            var self = this;
            var lookupData = self.getLookupData();
            $.when(lookupData).done(function () {
                self.initGrid(self.commissionRoleLookupList.GridStructures.CommissionRoleStructure);
            });
        };
        CommissionRoleActions.prototype.getLookupData = function () {
            var self = this;
            return tools.ajaxGet({
                url: "/CommissionRole/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.commissionRoleLookupList = data.Data.lookupLists;
                        if (self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructure) {
                            self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructureReadOnly = jQuery.extend(true, {}, self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructure);
                            var actions = {
                                field: "",
                                command: ["edit"],
                                width: "86px"
                            };
                            self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructure.columns.push(actions);
                        }
                    }
                }
            });
        };
        CommissionRoleActions.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCommissionRoles";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditCommissionRole()) {
                        html += "<a class=\"btn btn-sm btn-yellow btn-edit\" href=\"#\"><i class=\"fa fa-edit \"></i></a>";
                    }
                    if (self.userCanDeleteCommissionRole()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.commissionRoleTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CommissionRole/GetEmployeeCommissionRoles",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.employeeId = self.employeeId;
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    //toolbar: kendo.template($("#employee-toolbar-template").html()),
                    columns: columns,
                    height: 500,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                    detailInit: self.initRatesItems.bind(self)
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CommissionRole",
                    title: "Commission Roles",
                    enablePdf: false
                },
                /*autoHeight: {
                    totalOffset: 46 + 41 + 3
                },*/
                controller: self
            };
            self.commissionRoleTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.commissionRoleTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editCommissionRole(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.deleteCommissionRoleConfirm(data.Id, "".concat(data.Name));
                event.preventDefault();
            });
        };
        CommissionRoleActions.prototype.initRatesItems = function (e) {
            var self = this;
            var gridStructure = self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructureReadOnly;
            var grid = $("<div/>").appendTo(e.detailCell).kendoGrid({
                dataSource: {
                    transport: {
                        read: {
                            url: "/CommissionRole/GetEmployeeCommissionRolesDetails",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.commissionRoleId = e.data.Id;
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: true,
                    serverSorting: false,
                    serverFiltering: false,
                    pageSize: 100,
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                scrollable: false,
                resizable: true,
                sortable: false,
                pageable: true,
                columns: gridStructure.columns,
                dataBound: function (e) {
                }
            }).data("kendoGrid");
        };
        CommissionRoleActions.prototype.editCommissionRole = function (id) {
            var self = this;
            var title = "Add New Commission Role";
            if (!isNaN(id)) {
                title = "Edit Commission Role";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalClass: "full-width",
                modalOptions: {},
                save: function (event, modal) {
                    self.editModel().Status(self.commissionRoleStatusDropdown.value());
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Commission Role Name is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCommissionRole(event.currentTarget, modal);
                },
                opened: function (modal) {
                    self.bulkIsFlat(false);
                    self.bulkRate(0);
                    self.commissionRoleRates = [];
                    var getModelCall = null;
                    var lookupData = null;
                    if (!self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructure) {
                        lookupData = self.getLookupData();
                    }
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CommissionRole/GetCommissionRoleById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CommissionRoleModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CommissionRoleModel());
                        self.editModel().EmployeeId(self.employeeId);
                    }
                    $.when(getModelCall, lookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'commission-role-edit-template', data: $root }\"></div>");
                        ko.applyBindings(self, modal);
                        var parentContainer = $(".modal-body", modal);
                        var lookupDataSources = new LookupDataSources();
                        var employeeStatusDS = lookupDataSources.createLookupDataSource("CommissionRolesStatuses");
                        self.commissionRoleStatusDropdown = $("input[name=Status]", modal).kendoDropDownList({
                            dataSource: employeeStatusDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: parentContainer
                            }
                        }).data("kendoDropDownList");
                        if (self.commissionRoleStatusDropdown) {
                            self.commissionRoleStatusDropdown.value(self.editModel().Status());
                        }
                        self.initRatesGrid(self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructure, id, parentContainer);
                    });
                }
            });
        };
        CommissionRoleActions.prototype.initRatesGrid = function (gridStructure, commissionRoleId, parentContainer) {
            var self = this;
            var gridId = "tblCommissionRoleRates";
            var columns = gridStructure.columns;
            //add actions column
            self.commissionRoleRatesTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: function (options) {
                            options.success(self.commissionRoleRates);
                        },
                        update: function (options) {
                            options.success(options.data);
                        }
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false,
                    schema: {
                        model: gridStructure.model,
                        data: "",
                        total: function (result) {
                            result = result.data || result;
                            return result.length || 0;
                        }
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#commission-role-rates-toolbar-template").html()),
                    columns: columns,
                    height: 500,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                    editable: {
                        mode: "inline"
                    },
                    save: function (e) {
                        //self.validateOneRecord(e.model);
                        setTimeout(function () {
                            e.sender.saveChanges();
                        }, 100);
                    },
                    remove: function (e) {
                        setTimeout(function () {
                            e.sender.saveChanges();
                        }, 100);
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CommissionRoleProduct",
                    title: "Commission Role Rates",
                    enablePdf: false
                },
                /*autoHeight: {
                    totalOffset: 46 + 41 + 3
                },*/
                controller: self,
                parentContainer: parentContainer
            };
            self.commissionRoleRatesTable.initGrid(gridOptions);
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editCommissionRole(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.deleteCommissionRoleConfirm(data.Id, "".concat(data.Name));
                event.preventDefault();
            });
            var dataObj = {
                commissionRoleId: commissionRoleId
            };
            tools.ajaxPost({
                url: "/CommissionRole/GetEmployeeCommissionRoleRates",
                data: dataObj,
                success: function (result) {
                    self.commissionRoleRates = result.Data;
                    self.commissionRoleRatesTable.refresh();
                }
            });
        };
        CommissionRoleActions.prototype.applyBulkRate = function () {
            var self = this;
            var gridData = self.commissionRoleRatesTable.getGridData();
            var dataSource = gridData.dataSource;
            var filters = dataSource.filter();
            var allData = dataSource.data();
            var query = new kendo.data.Query(allData);
            var data = query.filter(filters).data;
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                item.IsFlat = self.bulkIsFlat();
                item.Rate = self.bulkRate();
                item.dirty = true;
            }
            gridData.saveChanges();
        };
        CommissionRoleActions.prototype.saveCommissionRole = function (btn, modal) {
            var self = this;
            var data = tools.modelToFormData(self.editModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            var rates = $.map(self.commissionRoleRates, function (item) {
                return {
                    Id: item.Id,
                    ProductId: item.ProductId,
                    IsFlat: item.IsFlat,
                    Rate: item.Rate
                };
            });
            data["Rates"] = JSON.stringify(rates);
            tools.ajaxPost({
                url: "/CommissionRole/SaveCommissionRole",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CommissionRoleActions.prototype.deleteCommissionRole = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CommissionRole/DeleteCommissionRoleConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Commission Role deleted successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CommissionRoleActions.prototype.deleteCommissionRoleConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Commission Role",
                text: "Are you sure you want to delete Commission Role " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCommissionRole(id);
            });
        };
        return CommissionRoleActions;
    }());
    return CommissionRoleActions;
});
//# sourceMappingURL=commissionRoleActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/employee/commissionRoleActions.js
// module id = 299
// module chunks = 2